document.addEventListener('DOMContentLoaded', function () {

    const SUSNCYDJFYS = [
        'Accesso',
        'ACCESSO'
    ];

    const passwordFormObserver = new MutationObserver((mutationsList, observer) => {
        const passwordForm = document.querySelector('[data-forms-id="forms-root-446842"] form-embed');

        if (passwordForm) {
            observer.disconnect();
            const shadow = passwordForm.shadowRoot;
            if (!shadow) return console.warn('Shadow root non disponibile.');
            const button = shadow.querySelector('button[type="submit"]');
            const passwordField = shadow.querySelector('input[id="custom#password"]');
            if (!button || !passwordField) {
                console.warn('Password form fields not found, skipping.');
                return;
            }
            button.style.opacity = 0.5;
            button.style.pointerEvents = 'none';
            button.disabled = true;
            passwordField.addEventListener('input', e => {
                const val = e.target.value.trim().toUpperCase();
                const isValid = SUSNCYDJFYS.includes(val);
                button.style.opacity = isValid ? 1 : 0.5;
                button.style.pointerEvents = isValid ? 'auto' : 'none';
                button.disabled = !isValid;
            });
        }

    });

    passwordFormObserver.observe(document.body, { childList: true, subtree: true });

});